<tgrid-restoration-metric-description-widget/>
<tgrid-outage-duration-definition-widget/>
<tgrid-restoration-metric-impact-level-widget/>
<tgrid-restoration-metric-recovery-duration-widget/>
<tgrid-restoration-metric-auc-widget/>
<tgrid-restoration-state-level-metric/>
<tgrid-restoration-state-level-metric allYears/>
